import {
  BrandAndMarketListItem,
  GuidIdCodeAndLabel,
  Int32IdAndLabel
} from '../../../integrated-client/models'

export interface IIdentitySettingsEditorData {
  id?: string | null,
  brandAndMarket?: BrandAndMarketListItem;
  distributionChannel?: Int32IdAndLabel,
  agency?: GuidIdCodeAndLabel,
  effectiveFrom?: object | null,
  effectiveTo?: object | null,
  disabled?: boolean,
  timeout?: number;
  allowEdit?: boolean
}

export interface IEditorData {
  identitySettingsData?: IIdentitySettingsEditorData
  validation?: any
}
export class EditorData implements IEditorData {

  identitySettingsData?: IIdentitySettingsEditorData
  validation?: any
}
